import { render } from "./LeaveEntitlementReport.vue?vue&type=template&id=9f775780&scoped=true"
import script from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"

import "./leave-entitlement-report.scss?vue&type=style&index=0&id=9f775780&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f775780"]])

export default __exports__